import areaStyle from './xAxis.splitArea.areaStyle'

export default {
  name: "splitArea",
  nickname: "分隔区域",
  desc:
    '坐标轴在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#grid">grid</a> 区域中的分隔区域，默认不显示。',
  type: "object",
  props: {
    interval: {
      name: "interval",
      nickname: "间隔",
      desc:
        '坐标轴分隔区域的显示间隔，在类目轴中有效。默认同 <a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.axisLabel.interval">axisLabel.interval</a> 一样。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示分隔区域。",
      value: false,
      defaultValue: false,
    },
    areaStyle,
  },
}
